import { datajs, getPageData } from '../shared/utils';
const google = window.google;

export default class PageHeaderMap {
	static getIcon(
		path = 'M15.96875,0 C7.40817045,0 0.46875,6.92542969 0.46875,15.46875 C0.46875,24.0120703 15.96875,45 15.96875,45 C15.96875,45 31.46875,24.0120703 31.46875,15.46875 C31.46875,6.92542969 24.5293295,0 15.96875,0 Z M3.28693182,15.46875 C3.28693182,8.48953125 8.97543182,2.8125 15.96875,2.8125 C22.9620682,2.8125 28.6505682,8.48953125 28.6505682,15.46875 C28.6505682,20.3301562 21.6022955,32.0663672 15.96875,40.1617969 C10.3352045,32.0663672 3.28693182,20.3301562 3.28693182,15.46875 Z M15.96875,8.4375 C12.0771932,8.4375 8.92329545,11.5850391 8.92329545,15.46875 C8.92329545,19.3524609 12.0771932,22.5 15.96875,22.5 C19.8603068,22.5 23.0142045,19.3524609 23.0142045,15.46875 C23.0142045,11.5850391 19.8603068,8.4375 15.96875,8.4375 Z M15.96875,19.6875 C13.6377614,19.6875 11.7414773,17.7950391 11.7414773,15.46875 C11.7414773,13.1424609 13.6377614,11.25 15.96875,11.25 C18.2997386,11.25 20.1960227,13.1424609 20.1960227,15.46875 C20.1960227,17.7950391 18.2997386,19.6875 15.96875,19.6875 Z'
	) {
		return {
			path: path,
			anchor: new google.maps.Point(16, 45), // Center bottom. SVG Icon is 32x45
			fillColor: '#E53935',
			fillOpacity: 1.0,
			strokeWeight: 0,
			scale: 1,
		};
	}

	static getActiveIcon() {
		return this.getIcon(
			'M15.96875,0 C24.5293295,0 31.46875,6.92542969 31.46875,15.46875 C31.46875,24.0120703 15.96875,45 15.96875,45 C15.96875,45 0.46875,24.0120703 0.46875,15.46875 C0.46875,6.92542969 7.40817045,0 15.96875,0 Z M15.96875,8.4375 C12.0771932,8.4375 8.92329545,11.5850391 8.92329545,15.46875 C8.92329545,19.3524609 12.0771932,22.5 15.96875,22.5 C19.8603068,22.5 23.0142045,19.3524609 23.0142045,15.46875 C23.0142045,11.5850391 19.8603068,8.4375 15.96875,8.4375 Z M15.96875,19.6875 C13.6377614,19.6875 11.7414773,17.7950391 11.7414773,15.46875 C11.7414773,13.1424609 13.6377614,11.25 15.96875,11.25 C18.2997386,11.25 20.1960227,13.1424609 20.1960227,15.46875 C20.1960227,17.7950391 18.2997386,19.6875 15.96875,19.6875 Z'
		);
	}

	static getContentHTML(location) {
		const lat = location?.marker?.lat;
		const lng = location?.marker?.lng;
		const content = location?.content;
		const image = content?.image || '';
		const title = content?.title;
		const text = content?.text;

		// Hack: Same as map marker, but positioned with js inside the infowindow in order to make the map marker appear "on top" of the infowindow
		const icon = datajs('infowindow-icon').innerHTML;

		let contentHtml = '';

		if (image) {
			let imageSrc = image?.sizes['post-thumbnail-s'] || null;
			let imageAlt = image?.alt;

			if (imageSrc) {
				contentHtml += `<img class="m-infowindow__image" src="${imageSrc}" alt="${imageAlt}" />`;
			}
		}

		if (title || text) {
			contentHtml += '<div class="m-infowindow__content">';

			if (title) {
				contentHtml += `<h2 class="m-infowindow__title">${title}</h2>`;
			}

			if (text) {
				contentHtml += `<div class="m-infowindow__text">${text}</div>`;
			}

			if (lat && lng) {
				contentHtml += `<a class="m-infowindow__link" href="https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}" target="_blank" rel="noopener">Hitta hit</a>`;
			}

			if (icon) {
				contentHtml += icon;
			}

			contentHtml += '</div>';
		}

		return contentHtml;
	}

	static init() {
		const mapElement = datajs('page-header-map');

		if (!mapElement) {
			return;
		}

		const postType = mapElement.dataset.postType || 'page';
		const pageId = parseInt(mapElement.dataset.pageId, 10);
		const initLat = parseFloat(mapElement.dataset.lat);
		const initLng = parseFloat(mapElement.dataset.lng);
		const initZoom = parseInt(mapElement.dataset.zoom, 10) || 14;
		const defaultIcon = this.getIcon();
		const activeIcon = this.getActiveIcon();

		let currentMarker = null;
		let infowindow = null;
		let map = null;

		const setupMarkers = (data) => {
			const mapStyle = data?.map_style;
			const locations = data?.locations;
			const boundbox = new google.maps.LatLngBounds();

			// Used for positioning of the infowindow
			let divHeightOfTheMap = mapElement.clientHeight;
			let offSetFromBottom = 16;

			// If no locations, just remove the loader
			if (!locations) {
				mapElement.classList.remove('has-loader');
				return;
			}

			// Init the map
			map = new google.maps.Map(mapElement, {
				center: { lat: initLat, lng: initLng },
				zoom: initZoom,
				disableDefaultUI: true,
				zoomControl: true,
			});

			// Remove loader
			google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
				mapElement.classList.remove('has-loader');
			});

			// Draw markers for each location
			locations.forEach((location) => {
				const lat = location?.marker?.lat;
				const lng = location?.marker?.lng;

				let contentHtml = this.getContentHTML(location);

				// Add marker to the map
				if (lat && lng) {
					const marker = new google.maps.Marker({
						position: new google.maps.LatLng(lat, lng),
						icon: defaultIcon,
						map: map,
						html: contentHtml,
						cursor: 'default',
						animation: google.maps.Animation.DROP,
					});

					// Markers with html content
					if (contentHtml) {
						marker.setCursor('pointer');

						google.maps.event.addListener(marker, 'click', function () {
							// Reset any existing active marker
							if (currentMarker) {
								currentMarker.setIcon(defaultIcon);
							}

							currentMarker = marker;
							currentMarker.setIcon(activeIcon);

							infowindow.setContent(this.html);
							infowindow.open(map, this);

							// Position the infowindow
							divHeightOfTheMap = mapElement.clientHeight;
							map.setCenter(marker.getPosition());
							map.panBy(0, -(divHeightOfTheMap / 2 - offSetFromBottom));
						});
					}

					// Add marker coordinates to bounding box
					boundbox.extend(new google.maps.LatLng(lat, lng));
				}
			});

			if (mapStyle) {
				try {
					map.setOptions({ styles: JSON.parse(mapStyle) });
				} catch (e) {
					console.error(e);
				}
			}

			if (locations.length > 1) {
				map.setCenter(boundbox.getCenter());
				map.fitBounds(boundbox, 150);
			}
		};

		// Fetch page map data
		getPageData({ postType: postType, pageId: pageId }, setupMarkers);

		// Give the infowindow some initial content
		infowindow = new google.maps.InfoWindow({
			content: 'Loading...',
			pixelOffset: new google.maps.Size(0, 41),
			disableAutoPan: true,
		});

		// Reset icon on close
		google.maps.event.addListener(infowindow, 'closeclick', () => {
			currentMarker.setIcon(defaultIcon);
		});
	}
}
